package com.milta.feature.legal.data.repository

import com.milta.feature.legal.data.remote.LegalDocumentApi
import com.milta.feature.legal.domain.entity.LegalDocument
import com.milta.feature.legal.domain.entity.LegalDocumentType
import com.milta.feature.legal.domain.repository.LegalDocumentRepository

class LegalDocumentRepositoryImpl(private val api: LegalDocumentApi) : LegalDocumentRepository {

    override suspend fun getLegalDocument(type: LegalDocumentType, lang: String): LegalDocument =
        api.getLegalDocument(type, lang).let { dto ->
            LegalDocument(title = dto.title, content = dto.content, updatedAt = dto.updatedAt)
        }
}
